import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { Icon } from 'common/components/Icon';

class InlineNotification extends React.Component {
  static propTypes = {
    icon: propTypes.string,
    text: propTypes.string.isRequired,
    title: propTypes.string,
  };

  render() {
    const { icon, title, text, ...props } = this.props;

    return (
      <div
        {...props}
        className={classNames('inline-notification', props.className)}
      >
        {icon && <Icon className="inline-notification__icon" name={icon} />}
        {title && (
          <span className="inline-notification__title heading--small">
            {title}
          </span>
        )}
        <span className="inline-notification__body text--body--small">
          {text}
        </span>
      </div>
    );
  }
}

export default InlineNotification;
